<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12>      
        <OrderSearch />

        <v-data-table
          class="elevation-0"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ 'items-per-page-options': [10, 30, 50, 100], showFirstLastPage: true, showCurrentPage: true }"
          @click:row="goToDetail"
        >
          <template v-slot:item.group="{ item }">
            <span class="text-capitalize"> 
              {{ item.group ? item.group.label : '-' }}
            </span>
          </template>

          <template v-slot:item.plate="{ item }">
            <span v-if="item.plate">
              <v-icon>directions_bus</v-icon> {{ item.plate }}
            </span>
            <span v-else>
              -
            </span>
          </template>
          
          <template v-slot:item.status="{ item }">
            {{ item.status.label }}
          </template>

          <template v-slot:item.valid_until="{ item }">
            {{ item.valid_until && item.valid_until.formatted ? item.valid_until.formatted : '-' }}
          </template>

          <template v-slot:item.created_at="{ item }">
            {{ item.created_at.formatted }}
          </template>

          <template v-slot:item.expiration="{ item }">
            <v-chip
              v-if="item.days_until_expiration !== null && item.days_until_expiration !== undefined"
              small
              :color="expirationColor(item.days_until_expiration)"
              :text-color="expirationTextColor(item.days_until_expiration)"
            >
              {{ expirationLabel(item.days_until_expiration) }}
            </v-chip>
            <span v-else>-</span>
          </template>
          
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{ name: 'orders-detail', params: { id: item.id } }"
              title="Visualizar Pedido"
            >
              <v-icon>visibility</v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import OrderSearch from './components/OrderSearch.vue';

export default {
  name: "OrderList",

  components: {
    OrderSearch
  },
  
  data: () => ({
    pagination: null,    
  }),

  computed: {
    ...mapState('order', ['table'])
  },

  watch: {
    pagination: {
      handler() {
        this.changePagination();
      },
      deep: true
    },
    
    '$route.query'() {
      this.changePagination();
    }
  },

  destroyed() {
    this.clear();
  },

  methods: {
    changePagination() {
      const { page, itemsPerPage } = this.pagination;
      const paginate = {
        ...this.table.paginate,
        inputPage: {
          page: page,
          per_page: itemsPerPage,
          sort: 'id:desc'
        }
      };
      this.changePage(paginate);
      this.search();
    },

    expirationColor(daysUntilExpiration) {
      if (daysUntilExpiration < 0) {
        return 'error';
      }

      if (daysUntilExpiration <= 45) {
        return 'orange';
      }

      return undefined;
    },

    expirationTextColor(daysUntilExpiration) {
      return this.expirationColor(daysUntilExpiration) ? 'white' : undefined;
    },

    expirationLabel(daysUntilExpiration) {
      if (daysUntilExpiration < 0) {
        return 'Vencido';
      }

      if (daysUntilExpiration <= 45) {
        return 'A vencer';
      }

      return 'Válido';
    },

    goToDetail({ id }) {
      this.$router.push({
        name: 'orders-detail',
        params: { id }
      });
    },

    ...mapActions('order', { search: 'SEARCH' }),
    ...mapActions('order', { clear: 'CLEAR' }),
    ...mapActions('order', { changePage: 'CHANGE_PAGE' })
  },
};
</script>